import React, { lazy } from 'react';
import {
    DockviewReact,
    DockviewDefaultTab,
    themeDark,
    themeLight
} from 'dockview';
import ActivityBar from './ActivityBar'
import 'dockview/dist/styles/dockview.css';
import Welcome from '../welcome';
import StatusBar from './StatusBar';
import { Icon, Toaster, Position } from '@blueprintjs/core';
import * as Blueprint from '@blueprintjs/core';
import * as DataTable from 'ag-grid-react';
import * as Dockview from 'dockview';
import MonacoEditor from 'react-monaco-editor';
import { Observable, from, Subject, share } from 'rxjs';
import  HelpSideBar from '../help/HelpSideBar';
import ExtensionSidebar from '../extensions/ExtensionSideBar';
// import 'ag-grid-community/styles/ag-grid.css';
// import 'ag-grid-community/styles/ag-theme-balham-dark.css'; 
import { 
    EXTENSION_ASSETS_URL, 
    fetchUserExtensions, 
    API_BASE_URL,
    getExtensionConfig,
    fetchExtensionInfo,
    installUserExtension,
    DOWNLOAD_ASSETS_URL
} from '../../services/api';
import { useSelector } from 'react-redux';
import ExtensionInfo from '../extensions/ExtensionInfo'
import InstalledExtensionInfoPanel from '../extensions/InstalledExtensionInfoPanel'
import { gl } from 'date-fns/locale';
import {
    registerExtension,
    unregisterExtension,
    setInstallingExtension,
    clearInstallingExtension
} from '../extensions/extensions-actions';
import { useDispatch } from 'react-redux';
import Output from './Output';
import Settings from '../settings/Settings';
import SettingsSidebarPanel from '../settings/SettingsSidebarPanel';
import { initializeSubscription } from '../subscription';
import { useStore } from 'react-redux';
import ActivityBarIcon from '../../components/ActivityBarIcon';
import { ReactSVG } from "react-svg";
import { registerBipLauncher } from './bipLauncher';
import {
    getStoredTheme,
    applyTheme,
    getTheme as readTheme,
    THEME_CHANGED_COMMAND,
    applySvgIconTheme,
} from './theme';

const SettingsPanel = React.memo(({ panelProps }) => (
    <Settings
        initialActiveItem={panelProps?.params?.initialActiveItem}
    />
));


// Create a global toaster instance
const AppToaster = Toaster.create({
    position: Position.TOP_RIGHT,
    maxToasts: 5,
});

const UILayout = (props) => {
    const { userDetails } = useSelector(state => state.session);
    const userDetailsRef = React.useRef(userDetails);
    React.useEffect(() => {
        userDetailsRef.current = userDetails;
    }, [userDetails]);
    const store = useStore();
    const GROUPS = ['primary-sidebar', 'main-panel', 'bottom-panel', 'secondary-sidebar', 'status-bar', 'active-bar'];
    const [api, setApi] = React.useState();
    const dispatch = useDispatch();

    //the available panels the extension will use.
    const [availablePanels, setAvailablePanels] = React.useState(GROUPS);

    // Global ResizeObserver error handler
    React.useEffect(() => {
        const handleGlobalError = (event) => {
            if (event.message && (
                event.message.includes('ResizeObserver loop completed with undelivered notifications') ||
                event.message.includes('ResizeObserver loop limit exceeded')
            )) {
                event.stopImmediatePropagation();
                event.preventDefault();
                return false;
            }
        };

        window.addEventListener('error', handleGlobalError);
        
        return () => {
            window.removeEventListener('error', handleGlobalError);
        };
    }, []);

    const [refreshKey, setRefreshKey] = React.useState(0);
    // let layoutEvent = null;
    const [ layoutEvent, setLayoutEvent ] = React.useState(null);
    const [theme, setThemeState] = React.useState(() => getStoredTheme());

    React.useEffect(() => {
        applyTheme(theme);
    }, [theme]);
    
    // Initialize global variable for synchronous access (avoids closure issues)
    globalThis.layoutEvent = globalThis.layoutEvent || null;

    const [ commands$, setCommands$ ] = React.useState({
        'layout-ready': new Subject(),
        [THEME_CHANGED_COMMAND]: new Subject()
    });

    const [componentList, setComponentList] = React.useState({
        // activityBar: ActivityBar,
        activityBar: (props) => <ActivityBar contributions={[]} {...props} commands$={commands$} getCommands$={function () { return commands$;}}/>,
        welcomePanel: Welcome,
        statusBar: StatusBar,
        helpSideBar: HelpSideBar,
        extensionSideBar: ExtensionSidebar,
        'extension-info': ExtensionInfo,
        'installed-extension-info': InstalledExtensionInfoPanel,
        'bottom-panel': Output,
        settingsPanel: SettingsPanel,
        settingsSidebarPanel: SettingsSidebarPanel,


        // default: (props: IDockviewPanelProps<{ title: string }>) => {
        default: (props) => {
            return (
                <div style={{ padding: '20px' }}>
                    { //props.params.title
                    }
                </div>
            );
        },
    });

    //save layout
    // React.useEffect(() => {
    //     if(!api) {
    //         return;
    //     }
        
    //     const disposable = api.onDidLayoutChange(() => {
    //         const layout = api.toJSON();
    //         console.log('layout:', layout);
    //         // localStorage.setItem('bodapro_layout', JSON.stringify(layout));
    //     });
        
    //     return () => disposable.dispose();
    // }, [api]);

    //globalThis
    globalThis['commands$'] = globalThis['commands$'] || commands$;
    if (!globalThis['commands$'][THEME_CHANGED_COMMAND]) {
        globalThis['commands$'][THEME_CHANGED_COMMAND] = commands$[THEME_CHANGED_COMMAND] || new Subject();
    }
    globalThis['bodaproComponents'] = globalThis['bodaproComponents']  || componentList;

    //installed extensions
    globalThis['BODAPRO_EXTENSIONS'] = globalThis['BODAPRO_EXTENSIONS'] || [];

    // Extension paths registry - tracks where each extension was loaded from
    globalThis['extensionPaths'] = globalThis['extensionPaths'] || {};

    // Manifest id per extension name (e.g. netcm -> bss.netcm). Recorded at load
    // time because teardown needs it after the extension folder is already gone.
    globalThis['extensionIds'] = globalThis['extensionIds'] || {};

    //Panel components
    let components = {};
    let _extComponents = {};
    let _commands = {};
    let tabs = {};
    
    // Component metadata storage (for icons, titles, etc.)
    let componentMetadata = {};
    globalThis['bodaproComponentMetadata'] = globalThis['bodaproComponentMetadata'] || {};
  
    //setup bodaContext
    //---------------------------------------------------
    window['bodapro-context'] = {

        updateExtensionList : (extensionName) => {
            globalThis['BODAPRO_EXTENSIONS'] = globalThis['BODAPRO_EXTENSIONS'] || [];
            if (globalThis['BODAPRO_EXTENSIONS'].indexOf(extensionName) === -1) {
                globalThis['BODAPRO_EXTENSIONS'].push(extensionName);
            }
        },

        getExntesionList: () => {
            return globalThis['BODAPRO_EXTENSIONS'];
        },

        // activateExtension:  async (extensionName)  => {
        //     console.log('activating extension:', extensionName);

        //     //web
        //     if(bodapro.platformType === 'web'){
        //         const entryURL  = `${EXTENSION_ASSETS_URL}/${ext.extension.name}/entry.js`;
        //         const icon = `${EXTENSION_ASSETS_URL}/${ext.extension.name}/assets/${ext.extension.name}.svg`;
        //         const someThing = await import(/* webpackIgnore: true */ entryURL);

        //         _contributions.push({
        //             'id': ext.extension.identifier, //extensionPackage.id,
        //             'name': ext.extension.name, //extensionPackage.name,
        //             'label': ext.extension.name, //extensionPackage.label,
        //             'version': ext.version, //extensionPackage.version,
        //             'description': ext.description, //extensionPackage.description,
        //             'icon': icon, //extensionPackage.icon.endsWith('.svg') ? bodapro.path.join(extDir, extensionPackage.icon) : extensionPackage.icon,
        //         });

        //         const importExt = someThing.default(); //----

        //         setCommands$({ ...commands$, ..._commands});
        //         globalThis['commands$'] = { ...globalThis['commands$'], ..._commands};
        //         setActivityBarContributions(_contributions);
        //     }

        // },

        //bts api 
        api: bodapro,

        getTheme: function () {
            return readTheme();
        },

        setTheme: function (nextTheme) {
            if (nextTheme !== 'light' && nextTheme !== 'dark') {
                return;
            }
            const applied = applyTheme(nextTheme);
            setThemeState(applied);
            globalThis.commands$ = globalThis.commands$ || {};
            if (!globalThis.commands$[THEME_CHANGED_COMMAND]) {
                globalThis.commands$[THEME_CHANGED_COMMAND] = new Subject();
            }
            globalThis.commands$[THEME_CHANGED_COMMAND].next({ theme: applied });
        },

        //addToast implmentation here 
        showToast: function (options) {
            const { message, intent = 'none', timeout = 3000, icon, action } = options;
            
            // Map intent strings to BlueprintJS Intent enum
            const intentMap = {
                'primary': Blueprint.Intent.PRIMARY,
                'success': Blueprint.Intent.SUCCESS,
                'warning': Blueprint.Intent.WARNING,
                'danger': Blueprint.Intent.DANGER,
                'none': Blueprint.Intent.NONE
            };

            const toastOptions = {
                message: message,
                intent: intentMap[intent] || Blueprint.Intent.NONE,
                timeout: timeout,
            };

            // Add icon if provided
            if (icon) {
                toastOptions.icon = icon;
            }

            // Add action if provided
            if (action) {
                toastOptions.action = action;
            }

            return AppToaster.show(toastOptions);
        },        
        
        commands$: commands$,

        registerCommand: function (name, callback) {
            // console.log('registerCommand called with name:', name);
            // console.log('Current globalThis commands$:', Object.keys(globalThis['commands$'] || {}));

            if(name in  globalThis['commands$']) {
                // console.log('Command already exists:', name);
                return;
            }

            const observable = new Subject();
            observable.subscribe((args) => {
                if( typeof callback === 'function') callback(args);
            });

            setCommands$({
                ...commands$,
                [name]: observable
            });

            _commands[name] = observable;

            setCommands$({ ...commands$, ..._commands});
            // console.log('Command registered:', name);
            // console.log('Updated _commands:', Object.keys(_commands));
            globalThis['commands$'] = { ...globalThis['commands$'], ..._commands};
            // console.log('Updated globalThis commands$:', Object.keys(globalThis['commands$'] || {}));
        },

        registerComponent: function (component) {
            components[component.id] = (panelProps) => <component.component 
                panelProps={panelProps}
                />;

            // Store component metadata (icon, title, etc.) if provided
            if (component.icon || component.title) {
                componentMetadata[component.id] = {
                    icon: component.icon,
                    title: component.title
                };
                globalThis['bodaproComponentMetadata'] = {
                    ...globalThis['bodaproComponentMetadata'],
                    ...componentMetadata
                };
            } else {
               // console.log('No icon or title provided for component');
            }

            setComponentList({ ...componentList, ...components});
            globalThis['bodaproComponents'] = { ...globalThis['bodaproComponents'], ...components};
        },

        deregisterComponent: function (componentId) {
            
            if(components[componentId] !== undefined) {
                delete components[componentId];
                setComponentList({ ...componentList, ...components});
                globalThis['bodaproComponents'] = { ...globalThis['bodaproComponents'], ...components};
            }
        },

        deRegisterComponent: function (componentId) {

            if(components[componentId] !== undefined) {
                delete components[componentId];
                setComponentList({ ...componentList, ...components});
                globalThis['bodaproComponents'] = { ...globalThis['bodaproComponents'], ...components};
            }
        },

        deRegisterExtension: function (extensionId) {
            //iterate over the components and remove the ones that match the extensionId
            //-------------------------------------
            Object.keys(globalThis['bodaproComponents']).forEach((key) => {
                // console.log('key:', key, 'extensionId:', extensionId);
                if (key.startsWith(extensionId)) {
                    // console.log('Deregistering component:', key);
                    // delete components[key];
                    delete globalThis['bodaproComponents'][key];
                }
            });
            setComponentList({ ...componentList, ...components});
            globalThis['bodaproComponents'] = { ...globalThis['bodaproComponents'], ...components};


            //deregister commands 
            //--------------------------------------------------------
            Object.keys(globalThis['commands$']).forEach((key) => {
                if (key.startsWith(extensionId)) {
                    // console.log('Deregistering command:', key);
                    delete globalThis['commands$'][key];
                }
            });
            setCommands$({ ...commands$, ...globalThis['commands$']});
            // console.log('globalThis.commands$:', globalThis['commands$']);
            globalThis['commands$'] = { ...globalThis['commands$'], ..._commands};  

            //deregister executable commands
            //--------------------------------------------------------
            if(globalThis.executableCommands$) {
                Object.keys(globalThis.executableCommands$).forEach((key) => {
                    if (key.startsWith(extensionId)) {
                        console.log('Deregistering executable command:', key);
                        delete globalThis.executableCommands$[key];
                    }
                });
            }
        },

        deRegisterCommand: function (commandName) {
            if(globalThis['commands$'][commandName] !== undefined) {
                delete globalThis['commands$'][commandName];
                setCommands$({ ...commands$, ...globalThis['commands$']});
            }
        },

        getPanels: function () {
            if(globalThis.layoutEvent === null || !globalThis.layoutEvent) return [];
            return globalThis.layoutEvent.api.panels;
        },

        removePanel: function (panelId) {
            if(globalThis.layoutEvent === null || !globalThis.layoutEvent) return;
            const panel = globalThis.layoutEvent.api.getPanel(panelId);
            if(panel !== undefined) {
                globalThis.layoutEvent.api.removePanel(panel);
            }
        },

        getDockViewApi: function () {
            return globalThis.layoutEvent?.api || null;
        },

        //trigger command
        triggerCommand: function (commandName, args) {
            if(globalThis.commands$[commandName] !== undefined) globalThis.commands$[commandName].next(args);
        },

        //register executable command (for request-response pattern)
        registerExecutableCommand: function (name, callback) {
            // Initialize global executable commands registry if not exists
            globalThis.executableCommands$ = globalThis.executableCommands$ || {};
            
            if(name in globalThis.executableCommands$) {
                console.warn(`Executable command ${name} already registered`);
                return;
            }
            
            // Store the callback directly
            globalThis.executableCommands$[name] = callback;
            console.log(`Executable command registered: ${name}`);
        },

        //execute command and return result (async)
        executeCommand: async function (commandName, args) {
            // Initialize if not exists
            globalThis.executableCommands$ = globalThis.executableCommands$ || {};
            
            if(globalThis.executableCommands$[commandName] === undefined) {
                throw new Error(`Executable command '${commandName}' not found. Available commands: ${Object.keys(globalThis.executableCommands$).join(', ')}`);
            }
            
            try {
                // Execute the command and wait for result
                const result = await globalThis.executableCommands$[commandName](args);
                return result;
            } catch (error) {
                console.error(`Error executing command ${commandName}:`, error);
                throw error;
            }
        },

        //deregister executable command
        deRegisterExecutableCommand: function (commandName) {
            if(globalThis.executableCommands$ && globalThis.executableCommands$[commandName] !== undefined) {
                delete globalThis.executableCommands$[commandName];
                console.log(`Executable command deregistered: ${commandName}`);
            }
        },

        //subscribe to command
        subscribeToCommand: function (commandName, callback) {

            // if(commandName in globalThis.commands$) return;

            //add delay to make sure the command is available
            let subscription = null;
            setTimeout(() => {
                if(globalThis.commands$[commandName] !== undefined) {
                    subscription = globalThis.commands$[commandName].subscribe((args) => {
                        if( typeof callback === 'function') callback(args);
                    });
                }
            }, 10);

            // Return subscription reference for cleanup
            return {
                unsubscribe: () => {
                    if(subscription) {
                        subscription.unsubscribe();
                        subscription = null;
                    }
                }
            };
        },

        //unsubscribe from command
        unsubscribeFromCommand: function (subscriptionRef) {
            if(subscriptionRef && typeof subscriptionRef.unsubscribe === 'function') {
                subscriptionRef.unsubscribe();
            }
        },

        setActivePanel: function (panelId) {
            if(globalThis.layoutEvent === null || !globalThis.layoutEvent) return;
            const panel = globalThis.layoutEvent.api.getPanel(panelId);
            if(panel !== undefined) {
                panel.api.setActive();
            }
        },

        addPanel: function ({id, title, componentName, groupId, extraProps, params, replacePanel, icon}) {
            // Use global variable for immediate access
            const currentLayoutEvent = globalThis.layoutEvent;
            
            if(currentLayoutEvent === null || !currentLayoutEvent?.api) {
                console.warn('Cannot add panel: layoutEvent is not initialized yet');
                return;
            }

            // Show the section if it's hidden
            let _groupId = groupId ? groupId : 'primary-sidebar'; //default to primary sidebar
            if (_groupId && globalThis.panelSizes && globalThis.panelSizes[_groupId]?.hidden) {
                this.showSection(_groupId);
            }

            if(currentLayoutEvent.api.getPanel(id) !== undefined && replacePanel !== true) {
                currentLayoutEvent.api.getPanel(id).api.setActive();
                return;
            }

            //get primary side panel group 
            const panelGroup = (groupId !== undefined && GROUPS.indexOf(groupId) > -1) ? currentLayoutEvent.api.getPanel(groupId).api.group : currentLayoutEvent.api.getPanel('primary-sidebar').api.group;

            //clear current panel
            if(replacePanel && currentLayoutEvent.api.getPanel(id) !== undefined){
                const _panel = currentLayoutEvent.api.getPanel(id);
                currentLayoutEvent.api.removePanel(_panel);
            }

            setComponentList(window['bodaproComponents']);
            
            // Prepare params with icon (icon from addPanel takes precedence over component metadata)
            const panelParams = {
                ...params,
                componentName: componentName,
                title: title
            };
            
            // Add icon to params if provided, otherwise try to get from component metadata
            console.log('=== addPanel Debug ===');
            console.log('addPanel called with:', { id, title, componentName, icon, params });
            console.log('icon parameter:', icon);
            console.log('componentName:', componentName);
            console.log('globalThis.bodaproComponentMetadata:', globalThis['bodaproComponentMetadata']);
            
            if (icon) {
                panelParams.icon = icon;
                console.log('Using icon from addPanel parameter:', icon);
            } else if (componentName && globalThis['bodaproComponentMetadata']?.[componentName]?.icon) {
                panelParams.icon = globalThis['bodaproComponentMetadata'][componentName].icon;
                console.log('Using icon from component metadata:', panelParams.icon);
            } else {
                console.log('No icon found - neither in addPanel param nor component metadata');
            }

            const newPanel = currentLayoutEvent.api.addPanel({
                id: id,
                component: componentName,
                title: title,
                position: { referenceGroup: panelGroup },
                ...extraProps,
                params: panelParams
            });
            
            console.log('Panel created:', newPanel);
            console.log('Panel params after creation:', newPanel?.params);

        },

        updatePanelParams: function (panelId, params) {
            if(globalThis.layoutEvent === null || !globalThis.layoutEvent?.api) {
                console.warn('Cannot update panel params: layoutEvent is not initialized yet');
                return;
            }
            const panel = globalThis.layoutEvent.api.getPanel(panelId);
            if (panel) {
                panel.api.updateParameters(params);
            }
        },

        // Hide a section/panel
        hideSection: function (sectionName) {
            if (globalThis.layoutEvent === null || !globalThis.layoutEvent) return;

            const panel = globalThis.layoutEvent.api.getPanel(sectionName);
            if (!panel) return;

            // Initialize panel sizes storage if not exists
            globalThis.panelSizes = globalThis.panelSizes || {};

            // Always store current size and constraints before hiding
            const currentSize = panel.api.size;
            // Store default constraints based on panel type since getConstraints() doesn't exist
            let currentConstraints = {};
            if (sectionName === 'active-bar') {
                currentConstraints = { maximumWidth: 60, minimumWidth: 60 };
            } else if (sectionName === 'status-bar') {
                currentConstraints = { maximumHeight: 30, minimumHeight: 30 };
            } else {
                // For other panels, use empty constraints (no minimums set)
                currentConstraints = {};
            }
            globalThis.panelSizes[sectionName] = {
                ...currentSize,
                constraints: currentConstraints
            };

            // Hide panel - set minimum constraints to 0 FIRST, then set size to 0
            if (sectionName === 'bottom-panel' || sectionName === 'status-bar') {
                panel.api.group.api.setConstraints({
                    minimumHeight: 0,
                    maximumHeight: undefined
                });
                panel.api.setSize({ height: 0 });
            } else {
                panel.api.group.api.setConstraints({
                    minimumWidth: 0,
                    maximumWidth: undefined
                });
                panel.api.setSize({ width: 0 });
            }

            // Special handling: when primary sidebar is minimized, ensure secondary sidebar stays minimized
            if (sectionName === 'primary-sidebar') {
                const secondaryPanel = globalThis.layoutEvent.api.getPanel('secondary-sidebar');
                const secondaryPanelData = globalThis.panelSizes['secondary-sidebar'];
                if (secondaryPanelData && secondaryPanelData.hidden) {
                    // Secondary sidebar was hidden, hide it again to ensure it stays hidden
                    if (secondaryPanel) {
                        secondaryPanel.api.group.api.setConstraints({
                            minimumWidth: 0,
                            maximumWidth: undefined
                        });
                        secondaryPanel.api.setSize({ width: 0 });
                    }
                }

                // reset the secondary sidebar constraints to allow it to be resized when primary sidebar is shown again
                if (secondaryPanelData === undefined || (secondaryPanelData && !secondaryPanelData?.hidden)) {
                    if(secondaryPanel) {
                        secondaryPanel.api.group.api.setConstraints({
                            minimumWidth: 200
                        });
                        secondaryPanel.api.setSize({ width: 300 });
                    }
                }
            }

            globalThis.panelSizes[sectionName].hidden = true;
        },

        // Show a section/panel . same as show PanelGroup
        showSection: function (sectionName) {
            if (globalThis.layoutEvent === null || !globalThis.layoutEvent) return;

            const panel = globalThis.layoutEvent.api.getPanel(sectionName);
            if (!panel) return;

            // Initialize panel sizes storage if not exists
            globalThis.panelSizes = globalThis.panelSizes || {};

            const panelData = globalThis.panelSizes[sectionName];

            // Restore or set appropriate constraints first, then set size
            if (sectionName === 'bottom-panel') {
                panel.api.group.api.setConstraints({
                    minimumHeight: 50
                });
                panel.api.setSize({ height: 100 });
            } else if (sectionName === 'status-bar') {
                panel.api.group.api.setConstraints({
                    maximumHeight: 30,
                    minimumHeight: 30
                });
                panel.api.setSize({ height: 30 });
            } else if (sectionName === 'primary-sidebar') {
                panel.api.group.api.setConstraints({
                    minimumWidth: 200
                });
                panel.api.setSize({ width: 400 });
            } else if (sectionName === 'secondary-sidebar') {
                panel.api.group.api.setConstraints({
                    minimumWidth: 200
                });
                panel.api.setSize({ width: 300 });
            } else if (sectionName === 'active-bar') {
                panel.api.group.api.setConstraints({
                    maximumWidth: 60,
                    minimumWidth: 60
                });
                panel.api.setSize({ width: 60 });
            }

            if (panelData) {
                globalThis.panelSizes[sectionName].hidden = false;
            }
        },

        // Toggle hide/show a section/panel (legacy function)
        toggleSection: function (sectionName) {
            if (globalThis.layoutEvent === null || !globalThis.layoutEvent) return;

            const panel = globalThis.layoutEvent.api.getPanel(sectionName);
            if (!panel) return;

            globalThis.panelSizes = globalThis.panelSizes || {};
            const isHidden = globalThis.panelSizes[sectionName]?.hidden || false;

            if (isHidden) {
                this.showSection(sectionName);
            } else {
                this.hideSection(sectionName);
            }
        },

        setAvailablePanels: function (panels) {
            setAvailablePanels(panels);
        },

        hidePanelGroupHeader: function (panelId) {
            if (globalThis.layoutEvent === null || !globalThis.layoutEvent) return;
            const panel = globalThis.layoutEvent.api.getPanel(panelId);
            if (panel) {
                panel.group.header.hidden = true;
            }
        },

        showPanelGroupHeader: function (panelId) {
            if (globalThis.layoutEvent === null || !globalThis.layoutEvent) return;
            const panel = globalThis.layoutEvent.api.getPanel(panelId);
            if (panel) {
                panel.group.header.hidden = false;
            }
        },

        // Get the path from which an extension was loaded
        getExtensionPath: function (extensionName) {
            return globalThis['extensionPaths']?.[extensionName] || null;
        },

        // Internal: Register an extension's load path (called during extension activation)
        _registerExtensionPath: function (extensionName, path) {
            globalThis['extensionPaths'] = globalThis['extensionPaths'] || {};
            globalThis['extensionPaths'][extensionName] = path;
        }

    };
    //eof: bodapro context---------------------------------------------------------------------------------------------------

    // Initialize subscription module (base module, not extension)
    React.useEffect(() => {
        if (userDetails && userDetails.token && window['bodapro-context']) {
            // Only initialize once when user is authenticated and BodaProContext is ready
            if (!window.__subscriptionModuleInitialized) {
                try {
                    // Ensure global executable commands registry exists
                    // globalThis.executableCommands$ = globalThis.executableCommands$ || {};
                    
                    console.log('Initializing subscription module...');
                    console.log('Store available:', !!store);
                    console.log('BodaProContext available:', !!window['bodapro-context']);
                    console.log('Current executable commands:', Object.keys(globalThis.executableCommands$ || {}));
                    
                    initializeSubscription(store);
                    window.__subscriptionModuleInitialized = true;
                    console.log('Subscription module initialization complete');
                    
                    // Verify command was registered
                    const availableCommands = Object.keys(globalThis.executableCommands$ || {});
                    console.log('Available executable commands after init:', availableCommands);
                    
                    if (globalThis.executableCommands$['subscription.open']) {
                        console.log('✓ subscription.open command verified in global registry');
                    } else {
                        console.error('✗ subscription.open command NOT found in global registry after initialization');
                        console.error('Available commands:', availableCommands);
                    }
                } catch (error) {
                    console.error('Failed to initialize subscription module:', error);
                    console.error('Error stack:', error.stack);
                }
            } else {
                // Already initialized, but verify command still exists
                if (!globalThis.executableCommands$?.['subscription.open']) {
                    console.warn('⚠ subscription.open command missing, re-initializing...');
                    window.__subscriptionModuleInitialized = false;
                }
            }
        }
    }, [userDetails, store, window.commands$]);


    // Register core authentication executable commands
    window['bodapro-context'].registerExecutableCommand('bodapro.auth.getCurrentUser', async function () {
        const current = userDetailsRef.current;
        if (!current) {
            return {
                success: false,
                user: null,
                authenticated: false
            };
        }
        return {
            success: true,
            user: current,
            authenticated: true
        };
    });

    window['bodapro-context'].registerExecutableCommand('bodapro.auth.getApiBaseUrl', async function () {
        return {
            success: true,
            baseUrl: API_BASE_URL,
            environment: window?.location?.port === '3000' ? 'development' : 'production'
        };
    });

    window['bodapro-context'].registerExecutableCommand('bodapro.auth.getToken', async function () {
        // Must read the ref: registerExecutableCommand keeps only the first
        // registration, so a direct userDetails read is the pre-login closure.
        const token = userDetailsRef.current?.token;

        if (!token) {
            return {
                success: false,
                token: null,
                authenticated: false,
            };
        }

        return {
            success: true,
            token,
            authenticated: true,
        };
    });

    window['bodapro-context'].registerExecutableCommand('bodapro.extensions.install', async function ({ name }) {
        if (!name) {
            throw new Error('Extension name is required');
        }

        try {
            dispatch(setInstallingExtension(name));
            
            // Fetch configuration and metadata
            const [extConfig, extensionInfo] = await Promise.all([
                getExtensionConfig(name),
                fetchExtensionInfo(name)
            ]);

            if (!extConfig) {
                throw new Error(`Could not fetch configuration for extension: ${name}`);
            }

            const platformType = (window.bodapro || globalThis.bodapro)?.platformType;

            // Web platform installation
            if (platformType === 'web') {
                if (!extensionInfo?.id) {
                    throw new Error(`Could not resolve extension details for ${name}`);
                }

                if (!userDetailsRef.current?.token) {
                    throw new Error('Authentication required to install extensions');
                }

                const payload = {
                    extension_id: extensionInfo.id,
                    installed_version: extConfig.version,
                };

                await installUserExtension(userDetailsRef.current.token, payload);

                // Update global tracking list
                globalThis['BODAPRO_EXTENSIONS'] = globalThis['BODAPRO_EXTENSIONS'] || [];
                if (globalThis['BODAPRO_EXTENSIONS'].indexOf(name) === -1) {
                    globalThis['BODAPRO_EXTENSIONS'].push(name);
                }
                
                dispatch(registerExtension(name));
                
                return {
                    success: true,
                    message: 'Extension installed successfully. Please reload to effect changes.',
                    name
                };
            }

            // Desktop platform installation
            const config = await bodapro.getConfig();
            const result = await bodapro.installExtension({
                extension: extConfig,
                url: `${DOWNLOAD_ASSETS_URL}/${name}.zip`,
                bodaProConfigFile: config.configFile
            });

            if (result?.status === 'success') {
                return {
                    success: true,
                    message: 'Extension installed successfully. Please restart/reload BodaPro to effect changes.',
                    name
                };
            } else {
                throw new Error(result?.message || 'Installation failed');
            }
        } catch (error) {
            console.error(`Error installing extension ${name}:`, error);
            throw error;
        } finally {
            dispatch(clearInstallingExtension());
        }
    });

    window['bodapro-context'].registerExecutableCommand('bodapro.extensions.isInstalled', async function ({ name }) {
        if (!name) {
            throw new Error('Extension name is required');
        }

        const installedExtensions = globalThis['BODAPRO_EXTENSIONS'] || [];
        const isInstalled = installedExtensions.indexOf(name) > -1;

        return {
            success: true,
            isInstalled,
            name
        };
    });

    // Dynamically activate an extension at runtime
    window['bodapro-context'].registerExecutableCommand('bodapro.extensions.activate', async function ({ name }) {
        if (!name) {
            throw new Error('Extension name is required');
        }

        try {
            // Check if already loaded. A registered load path is required —
            // bodapro.extensions.install adds the name to BODAPRO_EXTENSIONS
            // without activating, so the name alone is not proof of activation.
            if (globalThis['BODAPRO_EXTENSIONS'].indexOf(name) > -1 && globalThis['extensionPaths']?.[name]) {
                return {
                    success: true,
                    message: 'Extension is already activated',
                    name
                };
            }

            const platformType = (window.bodapro || globalThis.bodapro)?.platformType;

            if (platformType === 'web') {
                // Web platform - load from EXTENSION_ASSETS_URL
                const entryURL = `${EXTENSION_ASSETS_URL}/${name}/entry.js`;
                const extensionPath = `${EXTENSION_ASSETS_URL}/${name}`;

                // Register extension path
                window['bodapro-context']._registerExtensionPath(name, extensionPath);

                // Import and activate
                const module = await import(/* webpackIgnore: true */ entryURL);
                const activate = module.default;
                if (typeof activate === 'function') {
                    activate();
                }

                // Update registry (may already be listed if it was just installed)
                if (globalThis['BODAPRO_EXTENSIONS'].indexOf(name) === -1) {
                    globalThis['BODAPRO_EXTENSIONS'].push(name);
                }
                dispatch(registerExtension(name));

                return {
                    success: true,
                    message: 'Extension activated successfully',
                    name
                };
            } else {
                // Desktop platform - load from file system
                const bodaProConfig = await bodapro.getConfig();
                const extensions = await bodapro.getInstalledExtensions(bodaProConfig.config);

                // Find the extension
                const extensionPackagePath = extensions.find(ext => {
                    const pkg = bodapro.require(ext);
                    return pkg.name === name;
                });

                if (!extensionPackagePath) {
                    throw new Error(`Extension ${name} not found in installed extensions`);
                }

                const extensionPackage = bodapro.require(extensionPackagePath);
                const extDir = bodapro.path.dirname(extensionPackagePath);
                const entryFile = bodapro.path.join(extDir, extensionPackage.entry);

                if (!bodapro.fs.existsSync(entryFile)) {
                    throw new Error(`Entry file not found: ${entryFile}`);
                }

                // Register extension path
                window['bodapro-context']._registerExtensionPath(name, extDir);
                if (extensionPackage.id) globalThis['extensionIds'][name] = extensionPackage.id;

                // Import and activate
                const module = await import(/* webpackIgnore: true */`file:${entryFile}`);
                const activate = module.default;
                if (typeof activate === 'function') {
                    activate();
                }

                // Update registry (may already be listed if it was just installed)
                if (globalThis['BODAPRO_EXTENSIONS'].indexOf(name) === -1) {
                    globalThis['BODAPRO_EXTENSIONS'].push(name);
                }
                dispatch(registerExtension(name));

                return {
                    success: true,
                    message: 'Extension activated successfully',
                    name
                };
            }
        } catch (error) {
            console.error(`Error activating extension ${name}:`, error);
            throw error;
        }
    });

    // Dynamically deactivate an extension at runtime
    window['bodapro-context'].registerExecutableCommand('bodapro.extensions.deactivate', async function ({ name }) {
        if (!name) {
            throw new Error('Extension name is required');
        }

        try {
            // Check if extension is loaded
            if (globalThis['BODAPRO_EXTENSIONS'].indexOf(name) === -1) {
                return {
                    success: true,
                    message: 'Extension is not currently active',
                    name
                };
            }

            // Deregister all components and commands for this extension.
            // deRegisterExtension matches registration keys by prefix, and
            // extensions register under their manifest id (e.g. "bss.netcm")
            // as often as under their name, so both prefixes are cleared.
            window['bodapro-context'].deRegisterExtension(name);

            const manifestId = globalThis['extensionIds']?.[name];
            if (manifestId && manifestId !== name) {
                window['bodapro-context'].deRegisterExtension(manifestId);
            }

            // Remove from registry
            globalThis['BODAPRO_EXTENSIONS'] = globalThis['BODAPRO_EXTENSIONS'].filter(ext => ext !== name);
            dispatch(unregisterExtension(name));

            // Remove from extension paths registry
            if (globalThis['extensionPaths']?.[name]) {
                delete globalThis['extensionPaths'][name];
            }

            if (globalThis['extensionIds']?.[name]) {
                delete globalThis['extensionIds'][name];
            }

            return {
                success: true,
                message: 'Extension deactivated successfully',
                name
            };
        } catch (error) {
            console.error(`Error deactivating extension ${name}:`, error);
            throw error;
        }
    });

    // Universal BIP launcher: bodapro.bip.open (lazy-loads bip if needed)
    registerBipLauncher();

    // Keyboard shortcuts for hiding/showing panels
    React.useEffect(() => {
        const handleKeyDown = (event) => {
            // Ctrl+B for primary sidebar toggle
            if (event.ctrlKey && event.key === 'b' && !event.shiftKey) {
                event.preventDefault();
                window['bodapro-context'].toggleSection('primary-sidebar');
            }
            // Ctrl+Shift+B for secondary sidebar toggle
            if (event.ctrlKey && event.shiftKey && event.key === 'B') {
                event.preventDefault();
                window['bodapro-context'].toggleSection('secondary-sidebar');
            }
            // Cmd+W or Ctrl+W to close active tab
            if ((event.metaKey || event.ctrlKey) && event.key === 'w') {
                event.preventDefault();
                if (globalThis.layoutEvent && globalThis.layoutEvent.api) {
                    const activeGroup = globalThis.layoutEvent.api.activeGroup;
                    if (activeGroup && activeGroup.activePanel) {
                        const activePanel = activeGroup.activePanel;
                        // Don't close system panels
                        if (!GROUPS.includes(activePanel.id)) {
                            globalThis.layoutEvent.api.removePanel(activePanel);
                        }
                    }
                }
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [layoutEvent]);

    // Register the toggle-layout-section command
    window['bodapro-context'].registerCommand('toggle-layout-section', function (params) {
        const { sectionName } = params;
        window['bodapro-context'].toggleSection(sectionName);
    });


    
    const fn = async () => {

        if(globalThis.layoutEvent === null || !globalThis.layoutEvent) return;

        // get extension list  
        let extensions =  [];

        // let _extComponents = {};
        // let _commands = {};
        let _contributions = [];

        //---WEB extensions
        //--------------------------------------------------------
        if(bodapro?.platformType === 'web'){
            // const ext = await import('file:./extensions/extension1/dist/extension1.js');
            extensions = await fetchUserExtensions(userDetails?.token);    
            
            
            //@todo: show error message such not connectivity
            if(extensions === undefined || extensions === null) return;

            extensions.forEach( async ext => {
                    const entryURL  = `${EXTENSION_ASSETS_URL}/${ext.extension.name}/entry.js`;
                    const icon = `${EXTENSION_ASSETS_URL}/${ext.extension.name}/assets/${ext.extension.name}.svg`;
                    // Extension path for web is the base URL for this extension's assets
                    const extensionPath = `${EXTENSION_ASSETS_URL}/${ext.extension.name}`;

                    // Register extension path BEFORE activation so extension can query it
                    window['bodapro-context']._registerExtensionPath(ext.extension.name, extensionPath);
                    if(ext.extension.identifier) globalThis['extensionIds'][ext.extension.name] = ext.extension.identifier;

                    const someThing = await import(/* webpackIgnore: true */ entryURL);

                    _contributions.push({
                        'id': ext.extension.identifier, //extensionPackage.id,
                        'name': ext.extension.name, //extensionPackage.name,
                        'label': ext.extension.name, //extensionPackage.label,
                        'version': ext.version, //extensionPackage.version,
                        'description': ext.description, //extensionPackage.description,
                        'icon': icon, //extensionPackage.icon.endsWith('.svg') ? bodapro.path.join(extDir, extensionPackage.icon) : extensionPackage.icon,
                    });

                    const importExt = someThing.default(); //----

                    setCommands$({ ...commands$, ..._commands});
                    globalThis['commands$'] = { ...globalThis['commands$'], ..._commands};
                    setActivityBarContributions(_contributions);

                    //update the extension list
                    globalThis['BODAPRO_EXTENSIONS'].push(ext.extension.name)
            //---
            });


            //update the component list
            setComponentList(globalThis['bodaproComponents']);


            return;
        }
        //end of web|online ------------------------------------------------------ONLINE
        if(extensions === undefined) return;

        //---desktop extensions
        //--------------------------------------------------------
        const bodaProConfig = await bodapro.getConfig();
        extensions = await bodapro.getInstalledExtensions(bodaProConfig.config);
        let idx = 0;
        for (const extension of extensions) {
            idx++;
            //const packageJson = path.join(extension, 'package.json');
            const extensionPackage = bodapro.require(extension);
            const extDir = bodapro.path.dirname(extension);

            const entryFile = bodapro.path.join(extDir,extensionPackage.entry);

            //check if entry files exists 
            if(!bodapro.fs.existsSync(entryFile)) continue;
            _contributions.push({
                'id': extensionPackage.id,
                'name': extensionPackage.name,
                'label': extensionPackage.label,
                'version': extensionPackage.version,
                'description': extensionPackage.description,
                'icon': extensionPackage.icon.endsWith('.svg') ? bodapro.path.join(extDir, extensionPackage.icon) : extensionPackage.icon,
            });
            
            // Register extension path BEFORE activation so extension can query it
            window['bodapro-context']._registerExtensionPath(extensionPackage.name, extDir);
            if(extensionPackage.id) globalThis['extensionIds'][extensionPackage.name] = extensionPackage.id;

            // (async () => {
                try{
                    const someThing = await import(/* webpackIgnore: true */`file:${entryFile}`);
                    const importExt = someThing.default();
                // importExt.activate()
                }catch(e){
                    console.log('error:', e);
                }
            // })();

                //update the extension list
                globalThis['BODAPRO_EXTENSIONS'].push(extensionPackage.name)
                dispatch(registerExtension(extensionPackage.name));
        }

        setCommands$({ ...commands$, ..._commands});
        globalThis['commands$'] = { ...globalThis['commands$'], ..._commands};
        setComponentList(globalThis['bodaproComponents']);

        setActivityBarContributions(_contributions);

        // Auto-install default extensions on first run.
        // Use getRunConfig() (async) rather than BodaProRunConfig (sync cache) because
        // the cache may not be populated yet when this effect runs.
        const runConfig = await window.bodapro?.getRunConfig?.() || {};
        const defaultExts = runConfig.defaultExtensions || [];
        const defaultsReady = runConfig.defaultExtensionsReady ?? true;

        console.log('[defaults] runConfig.defaultExtensions:', defaultExts);
        console.log('[defaults] runConfig.defaultExtensionsReady:', defaultsReady);
        console.log('[defaults] platformType:', bodapro?.platformType);

        if (!defaultsReady && defaultExts.length > 0 && bodapro?.platformType === 'desktop') {
            const alreadyInstalled = new Set(globalThis['BODAPRO_EXTENSIONS'] || []);
            const toInstall = defaultExts.filter(name => !alreadyInstalled.has(name));

            console.log('[defaults] already installed:', [...alreadyInstalled]);
            console.log('[defaults] to install:', toInstall);

            if (toInstall.length > 0) {
                window['bodapro-context']?.showToast({
                    message: `Setting up ${toInstall.length} default extension${toInstall.length > 1 ? 's' : ''}…`,
                    intent: 'primary',
                    timeout: 0,
                });

                let failed = 0;
                for (const name of toInstall) {
                    try {
                        console.log(`[defaults] installing: ${name}`);
                        await window['bodapro-context'].executeCommand('bodapro.extensions.install', { name });
                        console.log(`[defaults] installed: ${name}`);
                    } catch(e) {
                        console.warn(`[defaults] Failed to install ${name}:`, e.message);
                        failed++;
                    }
                }

                await window.bodapro.markDefaultsInstalled();
                console.log('[defaults] marked as done');

                window['bodapro-context']?.showToast({
                    message: failed === 0
                        ? 'Default extensions installed. Reloading…'
                        : `${toInstall.length - failed} installed, ${failed} failed. Reloading…`,
                    intent: failed === 0 ? 'success' : 'warning',
                    timeout: 2000,
                });

                setTimeout(() => { window.bodapro.reloadWindow(); }, 2200);
            } else {
                console.log('[defaults] all defaults already installed — marking done');
                await window.bodapro.markDefaultsInstalled();
            }
        } else {
            console.log('[defaults] skipping — ready:', defaultsReady, 'count:', defaultExts.length, 'platform:', bodapro?.platformType);
        }
    }

    //activityBar contributions
    const [ activityBarContributions, setActivityBarContributions ] = React.useState([]);

    //Load extensions 
    React.useEffect(  () => {
        fn();
    }, [layoutEvent !== null]);  


React.useEffect(() => {

    if(globalThis.layoutEvent === null || !globalThis.layoutEvent){
        return;
    }
    const actvitiyBarPanel = globalThis.layoutEvent.api.getPanel('active-bar');
    actvitiyBarPanel.api.updateParameters({
        contributions: activityBarContributions,
        'keyA': 'Testing A'
    });

}, [activityBarContributions.length, layoutEvent !== null]);  // Keep state dependency for React

React.useEffect(() => {
    if (!globalThis.layoutEvent || !globalThis.layoutEvent.api) return;
    const currentPanels = globalThis.layoutEvent.api.panels;
    currentPanels.forEach(panel => {
        if (GROUPS.indexOf(panel.id) === -1 && availablePanels.indexOf(panel.id) === -1) {
            globalThis.layoutEvent.api.removePanel(panel);
        }
    });
}, [availablePanels, layoutEvent]);  // Keep state dependency for React

    // Helper function to render icon for panel tabs
    const renderPanelIcon = (icon) => {
        if (!icon) return null;
        
        // Check if it's an SVG file path
        if (typeof icon === 'string' && icon.endsWith('.svg')) {
            // For web platform, use the URL directly; for desktop, use file: protocol
            // Check both window.bodapro and global bodapro (for compatibility)
            const platformType = (window.bodapro || globalThis.bodapro)?.platformType;
            const iconSrc = platformType === 'web' ? icon : `file:${icon}`;
            return (
                <span style={{ marginRight: '8px', display: 'inline-flex', alignItems: 'center' }}>
                    <ReactSVG
                        key={theme}
                        src={iconSrc}
                        beforeInjection={(svg) => {
                            applySvgIconTheme(svg, { size: 16, theme });
                        }}
                    />
                </span>
            );
        }
        
        // Otherwise, treat as BlueprintJS icon name
        return (
            <span style={{ marginRight: '8px', display: 'inline-flex', alignItems: 'center' }}>
                <Icon icon={icon} size={16} intent="secondary" />
            </span>
        );
    };

    const PanelTab = (props) => {
        const onContextMenu = (event) => {
            event.preventDefault();
        };
        
        // Get icon from panel params or component metadata
        const panelIcon = props.params?.icon || 
                         (props.params?.componentName && globalThis['bodaproComponentMetadata']?.[props.params.componentName]?.icon);
        
        
        // If icon exists, wrap DockviewDefaultTab with icon
        if (panelIcon) {
            return (
                <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                    <div style={{ marginRight: '3px', display: 'flex', alignItems: 'center' }}>
                        {renderPanelIcon(panelIcon)}
                    </div>
                    <DockviewDefaultTab 
                        onContextMenu={onContextMenu} 
                        {...props} 
                        hideClose={false} 
                    />
                </div>
            );
        }
        
        return <DockviewDefaultTab onContextMenu={onContextMenu} {...props} hideClose={false} />;
    };

    const PanelTabNoClose = (props) => {
        const onContextMenu = (event) => {
            event.preventDefault();
        };
        
        // Get icon from panel params or component metadata
        const panelIcon = props.params?.icon || 
                         (props.params?.componentName && globalThis['bodaproComponentMetadata']?.[props.params.componentName]?.icon);
        
        
        // If icon exists, wrap DockviewDefaultTab with icon
        if (panelIcon) {
            return (
                <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                    <div style={{ marginRight: '3px', display: 'flex', alignItems: 'center' }}>
                        {renderPanelIcon(panelIcon)}
                    </div>
                    <DockviewDefaultTab 
                        onContextMenu={onContextMenu} 
                        {...props} 
                        hideClose={true} 
                    />
                </div>
            );
        }
        
        return <DockviewDefaultTab onContextMenu={onContextMenu} {...props} hideClose={false} />;
    };

    const BottomTab = (props) => {
        const onContextMenu = (event) => {
            event.preventDefault();
            // alert('context menu');
        };
        return <DockviewDefaultTab onContextMenu={onContextMenu} {...props} hideClose={true}/>;
    };

    const RightHeaderActions = (props) => {
        return (<div 
            style={{
                padding: 5,
                paddingTop: 10
            }}
            >
            <Icon icon="more" intent="secondary" />
        </div>);
    }

    //panel contents 
    components = {
        // activityBar: ActivityBar,
        activityBar: (props) => <ActivityBar contributions={[]} {...props} commands$={commands$} getCommands$={function () { return commands$;}}/>,
        welcomePanel: Welcome,
        statusBar: StatusBar,
        'extension-info': ExtensionInfo,
        'installed-extension-info': InstalledExtensionInfoPanel,

        // default: (props: IDockviewPanelProps<{ title: string }>) => {
        default: (props) => {
            return (
                <div style={{ padding: '20px' }}>
                    {props.params.title}
                </div>
            );
        },
    };

    //penal tabs 
    // let tabComponents = {
    //     panelTab: PanelTab,
    //     welcomeTab: PanelTab,
    //     outputTab: BottomTab
    // };

    const [ tabComponents, setTabComponents ] = React.useState({
        panelTab: PanelTab,
        welcomeTab: PanelTabNoClose,
        outputTab: BottomTab,
        extensionSideBar: PanelTabNoClose,
        docsSideBar: PanelTabNoClose,
        noCloseTab: PanelTabNoClose,
    });

    // const onReady = (event: DockviewReadyEvent) => {
    const onReady = (event) => {
        setApi(event.api);

        //set layout dockview event
        // layoutEvent = event;
        setLayoutEvent(event);  // For React re-renders
        globalThis.layoutEvent = event;  // For immediate synchronous access

        //activitybar
        const activeBar = event.api.addPanel({
            id: 'active-bar',
            component: 'activityBar',
            params: {
                title: 'Active Bar',
                contributions: []
            },
        });
        activeBar.group.locked = true;
        activeBar.group.header.hidden = true;
        activeBar.api.group.api.setConstraints({
            maximumWidth: 60,
            minimumWidth: 60,
        });
  
        //status bar 
        //----------------------------
        const statusBar = event.api.addPanel({
            id: 'status-bar',
            component: 'statusBar',
            title: 'Status',
            params: {
                title: 'Primary sidebar'
            },
            position: { referencePanel: 'active-bar', direction: 'below' },
        });
        statusBar.group.locked = true;
        statusBar.group.header.hidden = true;
        statusBar.api.group.api.setConstraints({
            maximumHeight: 30,
            minimumHeight: 30,
        });

        //primary sidebar
        //----------------------------
        const primarySidebar = event.api.addPanel({
            id: 'primary-sidebar',
            component: 'extensionSideBar',
            title: 'EXTENSIONS',
            tabComponent: 'extensionSideBar', 
            params: {
                title: 'Primary sidebar',
                icon: 'cube'
            },
            position: { referencePanel: 'active-bar', direction: 'right' },
        });
        primarySidebar.api.setSize({width: 300});
        primarySidebar.group.locked = true;
        primarySidebar.group.hideClose = true;

        //main panel
        //----------------------------
        const mainPanel = event.api.addPanel({
            id: 'main-panel',
            component: 'welcomePanel',
            title: 'Welcome',
            params: {
                title: 'Welcome',
                icon: 'home'
            },
            tabComponent: 'welcomeTab', 
            position: { referencePanel: 'primary-sidebar', direction: 'right' },
        });
        mainPanel.group.locked = true;
        mainPanel.group.hideClose = true;

        //secondry sidebar
        //----------------------------
        const secondarySidebar = event.api.addPanel({
            id: 'secondary-sidebar',
            component: 'helpSideBar',
            title: 'Documentation',
            tabComponent: 'noCloseTab',
            params: {
                title: 'Documentation',
                icon: 'book'
            },
            position: { referencePanel: 'main-panel', direction: 'right' },
        });
        secondarySidebar.api.setSize({width: 300});

        //bottom panel
        //----------------------------
        const bottomPanel = event.api.addPanel({
            id: 'bottom-panel',
            component: 'bottom-panel',
            title: 'OUTPUT',
            tabComponent: 'outputTab', 
            params: {
                title: 'Bottom Panel',
                icon: 'output'
            },
            position: { referencePanel: 'main-panel', direction: 'below' },
            
        });
        // Set initial height to 0 and minimum constraint to 0 to hide it
        bottomPanel.api.group.api.setConstraints({
            minimumHeight: 0
        });
        bottomPanel.api.setSize({height: 0});

        //set the parimary and secondary sidebar sizes again
        //----------------------------
        primarySidebar.api.setSize({width: 400});
        secondarySidebar.api.setSize({width: 300});

    };


    return  <DockviewReact
        theme={theme === 'light' ? themeLight : themeDark}
        components={componentList}
        tabComponents={tabComponents}
        onReady={onReady}
        className={theme === 'light' ? 'dockview-theme-light' : 'dockview-theme-dark'}
        rightHeaderActionsComponent={RightHeaderActions}
        // defaultTabRenderer={PanelTab}
        defaultTabComponent={PanelTab}
    />
}

export default UILayout;